/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import bcimage from '../../../../../assets/svg-image/day_trade_success_unactive_account_bc.svg';
import success from '../../../../../assets/svg-icons/success.svg';
import StarFilled from '../../../../../assets/svg-icons/StarFilled.svg';
import StarOutlined from '../../../../../assets/svg-icons/StarOutlined.svg';
import SmileOutlined from '../../../../../assets/svg-icons/SmileOutlined.svg';
import './style.scss';
import { SuccessProps } from 'presentation/entities/success.entity';
import { trackingEvent } from 'data/usecases/tracking-event';

export const DayTradeSuceesUnactiveAcccount = ({ course }: SuccessProps): JSX.Element => {
    const [note, selectNote] = useState(0);
    const notes = [1, 2, 3, 4, 5];
    const [sendNote, setSendNote] = useState(false);

    useEffect(() => {
        const savedNote = localStorage.getItem('tradeNoteCourse');

        if (savedNote !== null) {
            setSendNote(true);
        }
    }, []);
    return (
        <div
            className="col-sm-12 unactive_account_body"
            style={{
                backgroundImage: `url(${bcimage})`,
            }}
        >
            <div className="container">
                <div className=" text_content_unactive_account">
                    <div>
                        <div className="congradulations_unactive_account">
                            <img src={success} alt="" />
                            <p>PARABÉNS!</p>
                        </div>
                        <div className="title_unactive_account">
                            <h1>Você concluiu o curso Day Trade para Iniciantes</h1>
                            <p>
                                Agora, você sabe tudo que precisa para começar a operar. Transfira recursos e ative sua
                                conta!
                            </p>
                        </div>
                    </div>
                    {!sendNote && (
                        <div className="star_unactive_acount">
                            <p>Avalie o curso</p>

                            {notes.map((n, i) => (
                                <img
                                    src={note >= n ? StarFilled : StarOutlined}
                                    onMouseEnter={() => selectNote(n)}
                                    onMouseLeave={() => selectNote(0)}
                                    onClick={() => {
                                        setSendNote(true);
                                        localStorage.setItem('tradeNoteCourse', `${n}`);
                                        trackingEvent.elementClicked({
                                            productAreaOrigin: 'Aprenda',
                                            element: 'Avalie o curso',
                                            group: 'Tela de Conclusão do curso',
                                            step: 'Não se aplica',
                                            text: course?.name,
                                            timeResponsavel: 'Sky',
                                            specificProperties: {
                                                Avaliações: `${n}`,
                                            },
                                        });
                                    }}
                                    alt=""
                                    key={i}
                                />
                            ))}
                        </div>
                    )}
                    {sendNote && (
                        <div className="star_unactive_acount">
                            <p>Agradecemos sua avaliação!</p>

                            <img src={SmileOutlined} alt="" />
                        </div>
                    )}
                    <a
                        href={'https://app.toroinvestimentos.com.br/home/transferencia?category=activeAccount'}
                        className="btn-next mb-2"
                        onClick={() => {
                            trackingEvent.elementClicked({
                                productAreaOrigin: 'Aprenda',
                                element: 'Ativar conta',
                                group: 'Tela de Conclusão do curso',
                                step: 'Não se aplica',
                                text: course?.name,
                                timeResponsavel: 'Sky',
                            });
                        }}
                    >
                        Ativar conta
                    </a>
                </div>
            </div>
        </div>
    );
};
